/**
 * JSB media / marketing tags hook (case-scoped).
 *
 * Implementations should be idempotent (guard against double-load / double-fire)
 * since `analytics()` may run multiple times under SPA routing.
 */
export function jsbmedia() {
    window.__sxmJsb = window.__sxmJsb || {};

    // Ensure gtag exists (loader/config lives in `sites/www.sxmtcpasettlement.com/index.js`).
    window.dataLayer = window.dataLayer || [];
    window.gtag =
        window.gtag ||
        function gtag() {
            window.dataLayer.push(arguments);
        };

    const slug = window.location.pathname.replace(/^\/+|\/+$/g, "").toLowerCase();

    /**
     * Meta Pixel base init (loads script + initializes pixel).
     * Fires once per session.
     *
     * CSV: Pixel ID 848073401427861
     */
    if (!window.__sxmJsb.meta_pixel_loaded) {
        window.__sxmJsb.meta_pixel_loaded = true;

        !(function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = (f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            });
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = true;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = true;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");

        window.fbq("init", "848073401427861");
    }

    // Track PageView per SPA route (avoid duplicate firing for same slug).
    if (window.__sxmJsb.meta_last_pageview_slug !== slug) {
        window.__sxmJsb.meta_last_pageview_slug = slug;
        if (typeof window.fbq === "function") {
            window.fbq("track", "PageView");
        }
    }

    /**
     * Google Ads page-load conversion for the form page.
     * CSV: send_to 'AW-10839088199/S-HVCOTLw5ADEMe4vbAo'
     */
    if (slug === "submit-claim") {
        const firedKey = "google_page_load_submit_claim";
        if (!window.__sxmJsb[firedKey]) {
            window.__sxmJsb[firedKey] = true;
            window.gtag("event", "conversion", {
                send_to: "AW-10839088199/S-HVCOTLw5ADEMe4vbAo",
            });
        }
    }

    /**
     * Click-based conversion hooks (matches vendor instructions).
     * - Google: gtag_report_conversion() for Submit Claim
     * - Meta: fbq('track','Lead') on claim submit button click
     *
     * CSV: send_to 'AW-10839088199/-X6MCN7agYsbEMe4vbAo'
     */
    if (!window.__sxmJsb.google_submit_conversion_fn) {
        window.__sxmJsb.google_submit_conversion_fn = true;
        window.gtag_report_conversion = function (url) {
            const callback = function () {
                if (typeof url !== "undefined") {
                    window.location = url;
                }
            };
            window.gtag("event", "conversion", {
                send_to: "AW-10839088199/-X6MCN7agYsbEMe4vbAo",
                event_callback: callback,
            });
            return false;
        };
    }

    if (!window.__sxmJsb.submit_click_listener_loaded) {
        window.__sxmJsb.submit_click_listener_loaded = true;
        document.addEventListener(
            "click",
            (event) => {
                const currentSlug = window.location.pathname
                    .replace(/^\/+|\/+$/g, "")
                    .toLowerCase();
                if (currentSlug !== "submit-claim") return;

                const submitButton = event.target?.closest?.("#submit-claim");
                if (!submitButton || submitButton.disabled) return;

                if (!window.__sxmJsb.google_submit_conversion_fired) {
                    window.__sxmJsb.google_submit_conversion_fired = true;
                    if (typeof window.gtag_report_conversion === "function") {
                        window.gtag_report_conversion();
                    } else {
                        window.gtag("event", "conversion", {
                            send_to: "AW-10839088199/-X6MCN7agYsbEMe4vbAo",
                        });
                    }
                }

                if (!window.__sxmJsb.meta_lead_fired) {
                    window.__sxmJsb.meta_lead_fired = true;
                    if (typeof window.fbq === "function") {
                        window.fbq("track", "Lead");
                    }
                }
            },
            true
        );
    }
}
